<div fxLayout="row" fxLayoutAlign="end end">
    <button class="dialog-close-button" mat-mini-fab color="warn" (click)="dialogRef.close()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div fxLayout="column" class="policy-container">
    <div fxLayout="row" fxLayoutAlign="end end">

        <ng-container *ngIf="client; else noClientTemplate">
            <app-entity [selectedClient]="client" (formSavedSuccess)="closeDialog()"></app-entity>
        </ng-container>
        <ng-template #noClientTemplate>
            <app-entity (formSavedSuccess)="closeDialog()"></app-entity>
        </ng-template>
    </div>
</div>
